import { t } from '../i18n';
import { useToast } from '../lib/toast';
import { enableWebPush, hideWebPushNotice, useWebPushNoticeHidden, useWebPushState } from '../lib/webpush';

// Hinweis auf der Übersicht, solange Push im Browser noch nicht gefragt wurde (iPhone vom Home-Bildschirm, PC).
// „Nicht jetzt“ blendet ihn in diesem Browser aus, Einschalten geht dann über das Konto-Menü.
export function WebPushNotice() {
  const state = useWebPushState();
  const hidden = useWebPushNoticeHidden();
  const turnOn = useTurnOnPush();
  if (state !== 'ask' || hidden) return null;
  return (
    <div className="notice" role="status">
      <div className="nt-r">
        <span className="nt-i" aria-hidden="true">
          🔔
        </span>
        <div className="tx">
          <b>{t('Push-Nachrichten einschalten')}</b>
          <small>{t('Sie erfahren sofort, wenn Ihre Kanzlei schreibt oder etwas braucht.')}</small>
        </div>
        <div className="nt-b">
          <button type="button" className="btn2" onClick={hideWebPushNotice}>
            {t('Nicht jetzt')}
          </button>
          <button type="button" className="btn2 dark" onClick={turnOn}>
            {t('Einschalten')}
          </button>
        </div>
      </div>
    </div>
  );
}

// Einschalten mit Antwort: eingeschaltet, im Browser blockiert, oder der Browser kann es nicht
export function useTurnOnPush() {
  const toast = useToast();
  return () =>
    void enableWebPush().then((r) =>
      toast(
        r === 'on'
          ? t('Push-Nachrichten sind eingeschaltet.')
          : r === 'denied'
            ? t(
                'Ihr Browser blockiert Push-Nachrichten. Sie können sie in den Einstellungen des Browsers für diese Seite erlauben.',
              )
            : t('Dieser Browser kann keine Push-Nachrichten empfangen. Neues sehen Sie weiter an der Glocke.'),
      ),
    );
}
